import React from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { translate, formatData } from '../../../../utils/util';

const PrintLabelListItem = (props) => {
    const { item } = props;
    return (
        <div
            key={`key_${props.item.createdOn}`}
            className="collection-item"
            style={{ backgroundColor: 'white', color: 'black', display: 'block' }}
        >
            <div className="row" style={{ marginBottom: '0px', padding: '10px' }}>
                <div className="col s10 no-padding">
                    <div className="col s12">{`${translate("part-number", 'physical-confirmation')}: ${(item.partNumberCode) || ''}`}</div>
                    <div className="col s12">{`${translate("invoice", 'physical-confirmation')}: ${(item.invoice) || ''}`}</div>
                    <div className="col s12">{`${translate("journey", 'physical-confirmation')}: ${(item.journey) || ''}`}</div>
                    <div className="col s12">{`${translate("cim", 'physical-confirmation')}: ${(item.cim) || ''}`}</div>
                    <div className="col s12">{`${translate("mastercim", 'physical-confirmation')}: ${(item.masterCim) || ''}`}</div>
                    <div className="col s12">{`${translate("cimpallet", 'physical-confirmation')}: ${(item.cimPallet) || ''}`}</div>
                    <div className="col s12">{`${translate("generation-date", 'physical-confirmation')}: ${formatData(item.createOn)}`}</div>
                    {item.error && <div className="col s12" style={{ color: 'IndianRed' }}>{`${translate('erro', 'general')}: ${item.error}`}</div>}
                </div>
                <div className="col s2 center" style={{ textAlign: 'right' }}>
                    <button
                        className="btn-floating btn-principal waves-effect waves-light"
                        type="button"
                        disabled={item.error}
                        onClick={() => { props.onClickItem(item) }}
                    >
                        <i className="material-icons prefix">local_printshop</i>
                    </button>
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = () => {
    return {
    };
};

const mapDispatchToProps = () => {
    return {
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(PrintLabelListItem));

